import React from 'react';

import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';

import { DeleteForecastDialog } from './delete-forecast-dialog';

interface DeleteForecastDialogProps {
  forecastId?: string;
  isOpen: boolean;
  onClose: () => void;
}

export const DeleteForecastDialogContainer = ({ forecastId, isOpen, onClose }: DeleteForecastDialogProps) => {
  const { resetKey } = useSidebarResetCounter(isOpen);

  if (forecastId) {
    return <DeleteForecastDialog key={resetKey} forecastId={forecastId} isOpen={isOpen} onClose={onClose} />;
  }
  return null;
};
